var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-box",style:(_vm.styObj)},[_vm._m(0),_c('div',{staticClass:"slot-content"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process-wrapper"},[_c('div',{staticClass:"process-box"}),_c('div',{staticClass:"pointer-box"})])
}]

export { render, staticRenderFns }